import { render, staticRenderFns } from "./RenderAttributes.vue?vue&type=template&id=028da0e8&scoped=true&"
import script from "./RenderAttributes.vue?vue&type=script&lang=js&"
export * from "./RenderAttributes.vue?vue&type=script&lang=js&"
import style0 from "./RenderAttributes.vue?vue&type=style&index=0&id=028da0e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028da0e8",
  null
  
)

export default component.exports